import Store from '@store';
const TableOfContentsView = require('../../../ui/top-submenu/contents/table-of-contents/view');

module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  show: function ({ element }) {
    if (!this.tableOfContentsView) {
      this.tableOfContentsView = new TableOfContentsView({ el: $(element) });
    }
    const tableOfContentsMetadata = Store.getState().metadata?.table_of_contents;
    this.tableOfContentsView.show(tableOfContentsMetadata);
  }
}, Backbone.Events);
